import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ModalController } from '@ionic/angular/standalone';
import { NetworkErrorService } from '../services/network-error.service';
import { ResultModalComponent } from '../result-modal/result-modal.component';

const DEBOUNCE_MS = 2500;
let lastShownAt = 0;

/** Extended so subscribers can skip showing their own popup when we already showed one. */
export interface HttpErrorResponseWithHandled extends HttpErrorResponse {
  connectionErrorHandled?: boolean;
}

@Injectable()
export class NetworkErrorInterceptor implements HttpInterceptor {
  constructor(
    private networkErrorService: NetworkErrorService,
    private modalController: ModalController,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (!isPlatformBrowser(this.platformId)) {
          return throwError(() => error);
        }
        const msg = this.networkErrorService.getUserMessage(error);
        if (msg) {
          const now = Date.now();
          if (now - lastShownAt >= DEBOUNCE_MS) {
            lastShownAt = now;
            this.modalController
              .create({
                component: ResultModalComponent,
                componentProps: {
                  type: 'error',
                  title: msg.title,
                  message: msg.message,
                  buttonText: 'OK'
                },
                cssClass: 'result-modal'
              })
              .then((modal) => modal.present());
          }
          (error as HttpErrorResponseWithHandled).connectionErrorHandled = true;
        }
        return throwError(() => error);
      })
    );
  }
}
